import React from 'react';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  const phoneNumber = '1234567890'; // Replace with actual WhatsApp number
  const message = 'Hello! I am interested in your seeds.';
  
  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <button 
      className="whatsapp-button" 
      onClick={handleClick}
      aria-label="Chat on WhatsApp"
    >
      <svg 
        viewBox="0 0 32 32" 
        className="whatsapp-icon"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          fill="currentColor" 
          d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.467c-2.482 0-4.908-0.646-7.07-1.87l-0.507-0.292-5.247 1.408 1.417-5.267-0.321-0.525c-1.331-2.178-2.039-4.693-2.039-7.254 0-7.589 6.178-13.767 13.767-13.767s13.767 6.178 13.767 13.767-6.178 13.767-13.767 13.767zM21.713 18.461c-0.288-0.144-1.707-0.843-1.971-0.939s-0.457-0.144-0.649 0.144-0.745 0.939-0.913 1.131c-0.168 0.192-0.336 0.216-0.624 0.072s-1.216-0.449-2.315-1.429c-0.857-0.764-1.435-1.707-1.603-1.995s-0.018-0.443 0.126-0.587c0.13-0.13 0.288-0.336 0.432-0.505s0.192-0.288 0.288-0.48c0.096-0.192 0.048-0.36-0.024-0.505s-0.649-1.565-0.889-2.141c-0.234-0.558-0.47-0.48-0.649-0.49-0.168-0.008-0.36-0.010-0.553-0.010s-0.505 0.072-0.769 0.36c-0.264 0.288-1.009 0.987-1.009 2.405s1.033 2.789 1.177 2.981c0.144 0.192 2.027 3.096 4.913 4.341 0.686 0.296 1.221 0.473 1.639 0.605 0.689 0.218 1.315 0.187 1.811 0.113 0.552-0.083 1.707-0.697 1.947-1.371s0.24-1.251 0.168-1.371c-0.072-0.12-0.264-0.192-0.553-0.336z"
        />
      </svg>
      <span className="whatsapp-text">Chat with us</span>
    </button>
  );
};

export default WhatsAppButton;
